import { Plus } from 'lucide-react';
import { Section, Container, SectionTitle } from '../../ui';
import styles from './Certifications.module.css';

const logos = [
  { src: '/images/logos/shopify.webp', alt: 'Shopify' },
  { src: '/images/logos/prestashop.png', alt: 'PrestaShop' },
  { src: '/images/logos/woocommerce.webp', alt: 'WooCommerce' },
  { src: '/images/logos/colissimo.svg', alt: 'Colissimo' },
  { src: '/images/logos/comparecycle.png', alt: 'CompaRecycle' },
  { src: '/images/logos/dpd-group.png', alt: 'DPD Group' },
  { src: '/images/logos/sellermania.png', alt: 'Sellermania' },
  { src: '/images/logos/alma.webp', alt: 'Alma' },
  { src: '/images/logos/mangopay.webp', alt: 'Mangopay' },
];

const SECONDARY_CELLS = new Set([0, 2, 5, 7]);
const PLUS_CELLS = new Set([0, 2, 5]);

export function Certifications() {
  return (
    <Section variant="light">
      <Container>
        <SectionTitle title="Nos partenaires" centered />
        <div className={styles.grid}>
          {logos.map((logo, i) => (
            <div
              key={logo.alt}
              className={`${styles.card} ${SECONDARY_CELLS.has(i) ? styles.secondary : ''}`}
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className={styles.logo}
                loading="lazy"
              />
              {PLUS_CELLS.has(i) && (
                <Plus className={styles.plus} />
              )}
            </div>
          ))}
        </div>
      </Container>
    </Section>
  );
}
